import { createContext } from 'react'
import { format as d3format } from 'd3'

export interface IChartContext
{
    fontFamily: string;
    valueFmtOptions: {
        prefix: string,
        decimals: number,
    }
    valueFmt: (n: number, decimals: number, prefix: string) => string
}

const format = (value: number, decimals: number = 2, prefix: string = '$') => {
    const fmt = new Intl.NumberFormat('en-US', {
        style: 'decimal',
        maximumFractionDigits: decimals,
        minimumFractionDigits: decimals > 2 ? 2 : decimals,
        notation: 'compact',
        compactDisplay: 'short',
    });
    return `${prefix}${fmt.format(value).toUpperCase()}`;
}

export const defaultChartContext = {
    valueFmtOptions: {
        prefix: "$",
        decimals: 2,
    },
    fontFamily: 'monospace',
    valueFmt(n: number, decimals: number, prefix: string) {
        const skipZeroes = decimals > 2 ? '~' : '';
        if (n < 1_000_000) {
            return prefix + d3format(`,.${decimals}${skipZeroes}f`)(n)
        }

        return format(n, decimals, prefix);
    },
}

export const ChartContext = createContext<IChartContext>(defaultChartContext)